import { useContext } from "react";
import * as FaIcons from "react-icons/fa";
import * as AiIcons from "react-icons/ai";
import { Link, useLocation } from "react-router-dom";
import { SidebarData } from "../../utils/menu-list-options";
import { IconContext } from "react-icons";
import { Context } from "../../context/context";
import { useState } from "react";

export default function Menu() {
  const { sidebar, setSidebar } = useContext(Context);
  const [data, setData] = useState(SidebarData.admin);
  const params = useLocation();
  const showSidebar = () => setSidebar(!sidebar);
  const userName = JSON.parse(localStorage.getItem("userName"));
  const { innerWidth } = window;

  function clickItemMenu() {
    if (innerWidth < 769) {
      showSidebar();
    }
  }

  return (
    <>
      <IconContext.Provider value={{ color: "#fff" }}>
        <div className="navbar">
          <Link to="#" className="menu-bars">
            <FaIcons.FaBars onClick={showSidebar} />
          </Link>
          <div className="text-and-link">
            <p className="welcome-text">{userName ? userName : ""}</p>
            <Link to="/">Sair</Link>
          </div>
        </div>
        <nav className={sidebar ? "nav-menu active" : "nav-menu"}>
          <ul className="nav-menu-items">
            <li className="navbar-toggle">
              <Link to="#" className="menu-bars" onClick={showSidebar}>
                <AiIcons.AiOutlineClose />
              </Link>
            </li>
            {data.map((item, index) => {
              return (
                <li
                  key={index}
                  className={
                    params.pathname.includes(item.path)
                      ? "nav-text-selected"
                      : "nav-text"
                  }
                >
                  <Link to={item.path} onClick={clickItemMenu}>
                    {item.icon}
                    <span className="span-title">{item.title}</span>
                  </Link>
                </li>
              );
            })}
          </ul>
        </nav>
      </IconContext.Provider>
    </>
  );
}
